/** Marque du front, fixée au build par `VUE_APP_DOMAIN_ENV` (`DVHE` | `AD`). */

export type Brand = 'devinci' | 'ad'

type BrandConfig = {
  logoSlug: string
  // null : libellé traduit
  documentTitle: string | null
  forgotPasswordUrl: string | null
  showFirstConnection: boolean
  showForgotPasswordHints: boolean
  loginNoticeKey: string
  particleColors: string[]
  particleLinkRgb: string
}

const BRAND_CONFIGS: Record<Brand, BrandConfig> = {
  devinci: {
    logoSlug: 'devinci',
    documentTitle: null,
    forgotPasswordUrl: null,
    showFirstConnection: true,
    showForgotPasswordHints: true,
    loginNoticeKey: 'authentication.useEmail',
    particleColors: ['#5a52d5', '#7b6fd4', '#6b63b5', '#9b8fd8', '#b8b4e8'],
    particleLinkRgb: '80, 60, 160'
  },
  ad: {
    logoSlug: 'ad',
    documentTitle: 'AD Education',
    forgotPasswordUrl: 'https://adpass.campus-ade.com/',
    showFirstConnection: false,
    showForgotPasswordHints: false,
    loginNoticeKey: 'authentication.useSchoolEmail',
    particleColors: ['#008f78', '#00ab8f', '#33bca5', '#66cdbc', '#bfeae3'],
    particleLinkRgb: '0, 171, 143'
  }
}

export const BRAND: Brand = process.env.VUE_APP_DOMAIN_ENV === 'AD' ? 'ad' : 'devinci'

export const BRAND_CONFIG: BrandConfig = BRAND_CONFIGS[BRAND]
